import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { APIResponse } from "./CommonApiSlice";

interface DeleteDBOnClassEnd extends APIResponse {
  response: string;
}

interface GetActiveStudentsCountResponse {
  questionId: string;
  students: {
    completedStudents: string[];
    inProgressStudents: string[];
  };
}

const BASE_URL: string = import.meta.env.VITE_TEST_FRESHERS_WS_BASE_URL;

export const websocketApiSlice = createApi({
  reducerPath: "websocketApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    deleteDBOnClassEnd: builder.mutation<
      DeleteDBOnClassEnd,
      { classRoomId: string }
    >({
      query: ({ classRoomId }) => ({
        url: `v1/websocket/${classRoomId}`,
        method: "DELETE",
      }),
    }),
    getActiveStudentsCount: builder.query<
      GetActiveStudentsCountResponse,
      { classRoomId: string; questionId: string }
    >({
      query: ({ classRoomId, questionId }) => ({
        url: `v1/websocket/active-students`,
        method: "POST",
        body: { classroomId: classRoomId, questionId },
      }),
    }),
  }),
});

export const {
  useDeleteDBOnClassEndMutation,
  useLazyGetActiveStudentsCountQuery,
} = websocketApiSlice;
